import { render, staticRenderFns } from "./AccountWorkflowForm.vue?vue&type=template&id=05a0f650&scoped=true"
import script from "./AccountWorkflowForm.vue?vue&type=script&lang=js"
export * from "./AccountWorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./AccountWorkflowForm.vue?vue&type=style&index=0&id=05a0f650&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0f650",
  null
  
)

export default component.exports